// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const DrivetrainEnum = {
  "AWD": "AWD",
  "FWD": "FWD",
  "RWD": "RWD",
  "BWD": "BWD",
  "OTHER": "OTHER"
};

const EngineCategoryEnum = {
  "GAS": "GAS",
  "DIESEL": "DIESEL",
  "ELECTRIC": "ELECTRIC",
  "HYBRID": "HYBRID",
  "STEAM": "STEAM",
  "JET": "JET",
  "PROP": "PROP",
  "OTHER": "OTHER"
};

const VehicleBodyStyleEnum = {
  "COMPACT": "COMPACT",
  "SEDAN": "SEDAN",
  "HATCHBACK": "HATCHBACK",
  "PICKUP_TRUCK": "PICKUP_TRUCK",
  "SUV": "SUV",
  "SPORTS": "SPORTS",
  "CRUISER": "CRUISER",
  "SPORTBIKE": "SPORTBIKE",
  "SEMI": "SEMI",
  "FREIGHT": "FREIGHT",
  "PASSENGER": "PASSENGER",
  "CARGO": "CARGO",
  "JET": "JET",
  "COMMERCIAL": "COMMERCIAL",
  "CARGO_SHIP": "CARGO_SHIP",
  "YACHT": "YACHT",
  "OTHER": "OTHER"
};

const VehicleTypeEnum = {
  "CAR": "CAR",
  "MOTORCYCLE": "MOTORCYCLE",
  "TRUCK": "TRUCK",
  "PLANE": "PLANE",
  "TRAIN": "TRAIN",
  "SHIP": "SHIP"
};

const TransmissionTypeEnum = {
  "MANUAL": "MANUAL",
  "AUTOMATIC": "AUTOMATIC",
  "CVT": "CVT",
  "SEMI_AUTOMATIC": "SEMI_AUTOMATIC",
  "OTHER": "OTHER"
};

const FuelTypeEnum = {
  "GASOLINE": "GASOLINE",
  "DIESEL": "DIESEL",
  "ELECTRIC": "ELECTRIC",
  "HYBRID": "HYBRID",
  "COAL": "COAL",
  "JETFUEL": "JETFUEL",
  "OTHER": "OTHER"
};

const { VehicleModelGeneralInfo } = initSchema(schema);

export {
  VehicleModelGeneralInfo,
  DrivetrainEnum,
  EngineCategoryEnum,
  VehicleBodyStyleEnum,
  VehicleTypeEnum,
  TransmissionTypeEnum,
  FuelTypeEnum
};